import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../core/stores/useAuthStore';
import useUIStore from '../../core/stores/useUIStore';
import {
  Button,
  View,
  Heading,
  IconButton,
  IconHamburgerLine,
  Avatar,
  Menu,
  Flex,
} from '@smarterservices/smarter-ui';
import LanguageSwitcher from './LanguageSwitcher';
import useTranslations from '../hooks/useTranslations';
import { HeaderProps } from '../types';

const Header = ({ title }: HeaderProps) => {
  const authStore = useAuthStore();
  const uiStore = useUIStore();
  const navigate = useNavigate();
  const { t } = useTranslations();

  const handleToggleSidebar = () => {
    uiStore.toggleSidebar();
  };

  const handleLogout = async () => {
    await authStore.logout();
    navigate('/login');
  };

  // Determine the dashboard title based on user role
  const dashboardTitle =
    title ||
    (authStore.user?.role === 'admin'
      ? t('dashboard.title', 'Admin Dashboard')
      : authStore.user?.role === 'proctor'
      ? t('proctor.dashboard.title', 'Proctor Dashboard')
      : authStore.user?.role === 'testTaker'
      ? t('testTaker.dashboard.title', 'Test Taker Dashboard')
      : authStore.user?.role === 'faculty'
      ? t('faculty.dashboard.title', 'Faculty Dashboard')
      : t('app.name', 'SmarterProctoring'));

  return (
    <View as="header" background="brand" padding="small">
      <Flex>
        <Flex.Item>
          <Flex>
            <Flex.Item padding="0 small 0 0">
              <IconButton
                withBackground={false}
                withBorder={false}
                color="primary-inverse"
                onClick={handleToggleSidebar}
                screenReaderLabel={t('navigation.toggleSidebar', 'Toggle Sidebar')}
              >
                <IconHamburgerLine />
              </IconButton>
            </Flex.Item>
            <Flex.Item>
              <Heading level="h2" margin="0">
                {dashboardTitle}
              </Heading>
            </Flex.Item>
          </Flex>
        </Flex.Item>
        <Flex.Item margin="0 0 0 auto">
          <Flex>
            <Flex.Item padding="0 small 0 0">
              <LanguageSwitcher />
            </Flex.Item>
            <Flex.Item padding="0 small 0 0">
              <Button color="primary-inverse" onClick={handleLogout}>
                {t('navigation.logout', 'Logout')}
              </Button>
            </Flex.Item>
            <Flex.Item>
              <Menu
                trigger={<Avatar name={authStore.userInitials || 'User'} size="small" />}
                placement="bottom end"
              >
                <Menu.Group label={t('navigation.userMenu', 'User Menu')}>
                  <Menu.Item onClick={() => navigate('/profile')}>
                    {t('navigation.profile', 'Profile')}
                  </Menu.Item>
                  <Menu.Item onClick={() => navigate('/settings')}>
                    {t('navigation.settings', 'Settings')}
                  </Menu.Item>
                  <Menu.Item onClick={handleLogout}>{t('navigation.logout', 'Logout')}</Menu.Item>
                </Menu.Group>
              </Menu>
            </Flex.Item>
          </Flex>
        </Flex.Item>
      </Flex>
    </View>
  );
};

export default Header;
